import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-120">
      <Header data-id="element-121" />
      <main className="flex-grow" data-id="element-122">{children}</main>
      <Footer data-id="element-123" />
    </div>;
}